<footer class="footer-wrapper footer-layout1 black-bg space-top">
    <div class="widget-area">
        <div class="container">
            <div class="newsletter-area d-none d-sm-block">
                <div class="newsletter-top">
                    <div class="row gy-4 align-items-center">
                        <div class="col-lg-10 col-sm-12">
                            <h2 class="newsletter-title text-white text-capitalize mb-0">Still You Need Our Support?
                            </h2>
                            <small>Don’t wait make a smart & logical quote here. Its pretty easy.</small>
                        </div>
                        <div class="col-lg-2 col-sm-12 text-center">
                            <a routerLink="/contact" class="th-btn style3">Contact Us <img
                                    src="/assets/img/icon/plane.svg" alt=""></a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row justify-content-between">
                <div class="col-md-6 col-xl-3">
                    <div class="widget footer-widget">
                        <div class="th-widget-about">
                            <div class="about-logo">
                                <a routerLink="/"><img src="/assets/img/logo1.png" alt="XipeTech"
                                        style="max-width: 60%;"></a>
                            </div>
                            <p class="about-text">Welcome to Xipe Tech, We provide the most responsive and functional IT
                                Services and solve business challenges with innovative technologies.
                            </p>
                            <div class="th-social">
                                <a href="https://www.facebook.com/xipetech/"><i class="fab fa-facebook-f"></i></a>
                                <a href="https://x.com/xipetech/"><i class="fab fa-x"></i></a>
                                <a href="https://www.linkedin.com/company/xipe-tech/"><i
                                        class="fab fa-linkedin-in"></i></a>
                                <a href="https://www.youtube.com/@XipeTechLucknow"><i class="fab fa-youtube"></i></a>
                                <a href="https://www.instagram.com/xipe.tech/"><i class="fab fa-instagram"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-xl-auto">
                    <div class="widget widget_nav_menu footer-widget">
                        <h3 class="widget_title">Our Services</h3>
                        <div class="menu-all-pages-container">
                            <ul class="menu">

                                <li><a routerLink="/website-development">Website Development</a></li>
                                <li><a routerLink="/mobile-development">Mobile Development</a></li>
                                <li><a routerLink="/design">UX/UI Design</a></li>
                                <li><a routerLink="/ios-development">iOS Development</a></li>
                                <li><a routerLink="/android-development">Android Development</a></li>
                                <li><a routerLink="/software-development">Software Development</a></li>
                                <li><a routerLink="/seo-services">SEO Services</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-xl-auto">
                    <div class="widget widget_nav_menu footer-widget">
                        <h3 class="widget_title">Useful Links</h3>
                        <div class="menu-all-pages-container">
                            <ul class="menu">
                                <li><a routerLink="/">Home</a></li>
                                <li><a routerLink="/about-us">About Us</a></li>
                                <li><a routerLink="/services">Our Services</a></li>
                                <li><a routerLink="/our-projects">Our Projects</a></li>
                                <li><a routerLink="/latest-news">Latest News</a></li>
                                <li><a routerLink="/contact">Contact Us</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-xl-auto">
                    <div class="widget footer-widget">
                        <h3 class="widget_title">Get In Touch</h3>
                        <div class="th-widget-contact">
                            <div class="info-box_text">
                                <div class="icon">
                                    <img src="/assets/img/icon/phone.svg" alt="img">
                                </div>
                                <div class="details">
                                    <p><a href="tel:+918090920216" class="info-box_link">+91-8090-920216</a></p>
                                </div>
                            </div>
                            <div class="info-box_text">
                                <div class="icon">
                                    <img src="/assets/img/icon/envelope.svg" alt="img">
                                </div>
                                <div class="details">
                                    <p><a href="mailto:support&#64;xipetech.com"
                                            class="info-box_link">support&#64;xipetech.com</a></p>
                                    <p><a href="mailto:hr&#64;xipetech.com"
                                            class="info-box_link">hr&#64;xipetech.com</a>
                                    </p>
                                </div>
                            </div>
                            <div class="info-box_text">
                                <div class="icon"><img src="/assets/img/icon/location-dot.svg" alt="img"></div>
                                <div class="details">
                                    <p><a href="https://maps.app.goo.gl/oaZs8hQLAYRGCyiN9" target="_blank">789 Inner
                                            1st Floor, 529C/486,
                                            Kamla Nehru Nagar, Jageshwarpuri, Shankar
                                            Purva-Ⅲ, Zone 7,
                                            <br>Lucknow - 226022 Uttar Pradesh, India
                                            Landmark: XT Building</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="copyright-wrap">
        <div class="container">
            <div class="row justify-content-lg-between align-items-center">
                <div class="col-lg-6">
                    <p class="copyright-text">Copyright &copy; {{ currentYear }} <a routerLink="/">XipeTech</a>. All
                        Rights
                        Reserved.
                    </p>
                </div>
                <div class="col-lg-6 text-center text-lg-end">
                    <div class="footer-links">
                        <ul>
                            <li><a routerLink="/privacy-policy">Terms & Conditions</a></li>
                            <li><a routerLink="/careers">Careers</a></li>
                            <li><a routerLink="/terms-and-conditions">Privacy Policy</a></li>
                        </ul>
                    </div>
                </div>
            </div>

        </div>
    </div>

</footer>